import { useState, useEffect } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import Role from "./Role";
import gearicon from "../../assets/shapes_svg/ambition/gearicon.svg";
import Carousel from "react-multi-carousel-18";
import keyboardArrowLeftIcon from "../../assets/shapes_svg/ambition/arrowcarouselleft.svg";
import keyboardArrowRightIcon from "../../assets/shapes_svg/ambition/arrowcarouselright.svg";
import closeArrowIcon from "../../assets/shapes_svg/ambition/close-arrow.svg";
import { ContainerBody } from "../../App";
import { AmbitionIntro } from "./components/AmbitionIntro";
import { CompanyAmbition } from "./components/CompanyAmbition";
import { CustomDepartment } from "./components/ActionPlans/CustomDepartment";
import { PurchaseDepartment } from "./components/ActionPlans/PurchasingDepartment";
import { MarketingDepartment } from "./components/ActionPlans/MarketingDepartment";
import { LogisticDepartment } from "./components/ActionPlans/LogisticDepartment";
import { ProductionDepartment } from "./components/ActionPlans/ProductionDepartment";
import { getDepartments } from "../../apis/Business/DepartmentEffortApi";
import { Department } from "./components/ActionPlans/Department";
import { useInvalidateQuery } from "../../components/InvalidateQueryContext";
import { ambitionDeptKey } from "../../apis/ApiKey/AmbitionDepartmentKey";
import { useUserAccess } from "../../components/WriteAccessContext";
import { useTranslation } from "react-i18next";
import { getBusinessDetail } from "../../apis/Business/Business";
import SBTIIcon from "../../assets/ambition_icons/sbti-icon.svg";
import SGDIcon from "../../assets/ambition_icons/sgd-icon.svg";
import UNGCIcon from "../../assets/ambition_icons/ungc-icon.svg";
import solutionLabIcon from "../../assets/ambition_icons/solutions-lab-icon.svg";

const Ambition = () => {
  const { t } = useTranslation();
  const [openSecondDept, setOpenSecondDept] = useState(false);
  const [departments, setDepartments] = useState([]);
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const { createDepartment, updateDepartment } = ambitionDeptKey;
  const [chosenTab, setChosenTab] = useState("main");
  const [businessName, setBusinessName] = useState("");
  const [shared, setShared] = useState({});
  const [activeMainBusinessName, setActiveMainBusinessName] = useState(null);
  const [writeAccess, setWriteAccess] = useState(false);
  const { setUserAccessType, setIsShare } = useUserAccess();
  const [year, setYear] = useState(null);
  const [newDepartment, setNewDepartment] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setYear(params.get("year"));

    // Optional: Add a listener for URL changes
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      setYear(params.get("year"));
    };

    window.addEventListener("popstate", handleUrlChange);
    return () => window.removeEventListener("popstate", handleUrlChange);
  }, []);

  const handleToggleActive = (mainBusinessName) => {
    setActiveMainBusinessName(mainBusinessName);
  };

  useEffect(() => {
    if (chosenTab === "main") {
      setUserAccessType("write");
    }
  }, [chosenTab, setUserAccessType]);

  useEffect(() => {
    fetchDepartments();
    getBusinessDetail({
      id: localStorage.getItem("id_business"),
      setName: setBusinessName,
    });
  }, []);
  const fetchDepartments = async () => {
    try {
      const { data, shared, writeAccess } = await getDepartments();

      setDepartments(data); // Update state for departments
      setShared(shared); // Update state for shared departments
      setWriteAccess(writeAccess);
    } catch (error) {
      console.error("Failed to fetch departments:", error);
    }
  };
  useEffect(() => {
    if (
      invalidateKey === createDepartment ||
      invalidateKey === updateDepartment
    ) {
      fetchDepartments();
    }
    resetKey();
  }, [createDepartment, updateDepartment, invalidateKey, resetKey]);

  const allDepartAmbitions = [
    {
      title: "SDG",
      link: "sdg",
      subheading: "Sustainable Development Goals",
      icon: SGDIcon,
    },
    {
      title: "UNGC",
      link: "ungc",
      subheading: "UN Global Compact",
      icon: UNGCIcon,
    },
    {
      title: "SBTi",
      link: "sbti",
      subheading: "Science Based Target initivative",
      icon: SBTIIcon,
    },
    {
      title: "Solutions Lab",
      link: "partnership",
      subheading: "Working together with other Business",
      icon: solutionLabIcon,
    },
    {
      title: "ESG",
      link: "esg",
      subheading: "Environmental Social & Governance",
    },
    {
      title: "B-CORP",
      link: "bcorp",
      subheading: "Benefit Corporation",
    },
    {
      title: "ERM",
      link: "erm",
      subheading: "Enterprise Risk Management",
    },
    {
      title: "E.U",
      link: "eugreendeal",
      subheading: "Continental Goals",
    },

    {
      title: "Value Chain",
      link: "valuechain",
      subheading: "Chain of Product/Service Creation",
    },

    {
      title: "Due diligence",
      link: "duediligence",
      subheading: "Mitigate Business Risk",
    },
  ];

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <div
        className="carousel-button-group"
        style={{
          position: "absolute",
          display: "flex",
          justifyContent: "space-between",
          width: "73%",
        }}
      >
        <img
          src={keyboardArrowLeftIcon}
          onClick={() => previous()}
          alt="Keyboard Arrow Left Icon"
        />
        <img
          src={keyboardArrowRightIcon}
          onClick={() => next()}
          alt="Keyboard Arrow Right Icon"
        />
      </div>
    );
  };

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <ContainerBody className="ambition__body">
      <>
        <div style={{ display: "flex" }}>
          <div
            className={`companydetail__info__ambition ${
              activeMainBusinessName === null ? "active" : ""
            }`}
            onClick={() => {
              setChosenTab("main");
              handleToggleActive(null);
              setIsShare(false);
              setUserAccessType("write");
            }}
          >
            <h6>{businessName ? businessName : t("Branches")}</h6>
          </div>
          {shared &&
            Object.keys(shared).map((mainBusinessName) => (
              <div
                key={mainBusinessName}
                className={`companydetail__info__ambition ${
                  activeMainBusinessName === mainBusinessName ? "active" : ""
                }`}
                onClick={() => {
                  setChosenTab(mainBusinessName);
                  setUserAccessType(writeAccess[mainBusinessName][0].is_write);
                  setIsShare(true);
                  handleToggleActive(mainBusinessName);
                }}
                style={{ cursor: "pointer" }}
              >
                <h6>{mainBusinessName}</h6>
              </div>
            ))}
        </div>
        <AmbitionIntro />
        <div>
          <h6 className="ambition__body__headersection">Company Ambitions</h6>
        </div>
        <div className="ambition__body__parent">
          <div className="ambition__body__items">
            {!openSecondDept ? (
              <Carousel
                swipeable={false}
                draggable={false}
                showDots={false}
                responsive={responsive}
                ssr={true}
                infinite={true}
                autoPlay={false}
                autoPlaySpeed={1000}
                arrows={false}
                customButtonGroup={<ButtonGroup />}
                renderButtonGroupOutside={true}
                keyBoardControl={true}
                transitionDuration={100}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={"desktop"}
                dotListClass="custom-dot-list-style"
                itemClass="px-2"
              >
                {allDepartAmbitions.map((depart, i) => (
                  <Link
                    key={i}
                    className="exceptionallink"
                    to={
                      "/ambition/" +
                      depart.link +
                      "/" +
                      chosenTab +
                      "?year=" +
                      year
                    }
                  >
                    <div
                      className="ambition__body__item"
                      style={{
                        padding: "20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <h4>{depart.title}</h4>
                      <h5>{depart.subheading}</h5>
                      <img
                        src={depart.icon ? depart.icon : gearicon}
                        alt="Gear Icon"
                      />
                    </div>
                  </Link>
                ))}
              </Carousel>
            ) : (
              <div style={{ width: "100%", padding: "0 60px" }}>
                {Array.from({
                  length: Math.ceil(allDepartAmbitions.length / 4),
                }).map((_, rowIndex) => (
                  <div
                    key={rowIndex}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom:
                        rowIndex < Math.ceil(allDepartAmbitions.length / 4) - 1
                          ? "32px"
                          : "0",
                    }}
                  >
                    {allDepartAmbitions
                      .slice(rowIndex * 4, (rowIndex + 1) * 4) // rowIndex represents each row starting 0. each row display 4 items
                      .map((depart, i) => (
                        <Link
                          key={i}
                          className="exceptionallink"
                          to={
                            "/ambition/" +
                            depart.link +
                            "/" +
                            chosenTab +
                            "?year=" +
                            year
                          }
                        >
                          <div
                            className="ambition__body__item"
                            style={{
                              padding: "20px",
                              justifyContent: "space-between",
                            }}
                          >
                            <h4>{depart.title}</h4>
                            <h5>{depart.subheading}</h5>
                            <img src={gearicon} alt="Gear Icon" />
                          </div>
                        </Link>
                      ))}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div
            style={{ width: "100%", cursor: "pointer" }}
            onClick={() => setOpenSecondDept(!openSecondDept)}
          >
            <img
              src={closeArrowIcon}
              alt="Close Arrow"
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="ambition__role__items">
          <div style={{ display: "flex", width: "100%" }}>
            <Link className="nav-link" to={"/ambition/ourcompany?year=" + year}>
              <Role title={"Our Company"} />
            </Link>
            <CompanyAmbition />
          </div>
        </div>

        <div>
          <h6 className="ambition__body__headersection">Action Plans</h6>
        </div>

        <div className="ambition__body__parent">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "20px",
              width: "100%",
              padding: "30px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <CustomDepartment
              user={
                chosenTab !== "main" ? writeAccess[chosenTab][0].user : null
              }
              setNewDepartment={setNewDepartment}
            />
            {newDepartment && <Department department={newDepartment} />}

            {chosenTab === "main"
              ? departments
                  .filter(
                    (department) =>
                      !newDepartment || department.id !== newDepartment.id
                  )
                  .map((department, i) => {
                    if (department.name === "Purchasing") {
                      return (
                        <PurchaseDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    } else if (department.name === "Marketing") {
                      return (
                        <MarketingDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    } else if (department.name === "Logistic") {
                      return (
                        <LogisticDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    } else if (department.name === "Production") {
                      return (
                        <ProductionDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    }
                    return (
                      <Department key={department.id} department={department} />
                    );
                  })
              : (shared[chosenTab] || [])
                  .filter(
                    (department) =>
                      !newDepartment || department.id !== newDepartment.id
                  )
                  .map((department) => {
                    if (department.name === "Purchasing") {
                      return (
                        <PurchaseDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    } else if (department.name === "Marketing") {
                      return (
                        <MarketingDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    } else if (department.name === "Logistic") {
                      return (
                        <LogisticDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    } else if (department.name === "Production") {
                      return (
                        <ProductionDepartment
                          key={department.id}
                          department={department}
                        />
                      );
                    }
                    return (
                      <Department key={department.id} department={department} />
                    );
                  })}
          </div>
        </div>
      </>
    </ContainerBody>
  );
};

export default Ambition;
